<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-md-12">
          <div class="button-items mb-1" style="float: left;padding-left: 1%;">
            <h2>Disbursements Export</h2>
          </div>

          <div class="button-items mb-1" style="float: right;">
            <button class="btn btn-primary btn-sm" (click)="loadExportGrid(lastTableLazyLoadEvent)" pTooltip="Refresh table" appActionTooltip><i
            class="mdi mdi-reload"></i></button>
            <button class="btn btn-primary btn-sm " (click)="dt.clear()" pTooltip="Clear all column filters and sorting" appActionTooltip>Clear <i class="mdi mdi-filter-remove"></i></button>
            <button class="btn btn-success btn-sm" pTooltip="Generate a new export batch" appActionTooltip (click)="generateData()">Generate Export Data</button>
          </div>
        </div>
      </div>
      <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadExportGrid($event)" [value]="disbRecordJobs"
        dataKey="id" styleClass="p-datatable-disbRecordJobs" [rowHover]="true" [rows]="10"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0" paginatorDropdownAppendTo="body">


        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width:6rem">
              Preview/Download
            </th>
            <th pSortableColumn="id">
              <div >
                Batch Id
                <p-sortIcon field="id"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="numeric" field="id" display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="createdDate">
              <div >
                Date Created
                <p-sortIcon field="createdDate"></p-sortIcon>
                <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptionsDate"  type="date" field="createdDate"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="description">
              <div >
                Description
                <p-sortIcon field="description"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="description"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="createdBy">
              <div >
                User Created
                <p-sortIcon field="createdBy"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="createdBy"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="recordsCount">
              <div >
                Total Number of Records
                <p-sortIcon field="recordsCount"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="recordsCount"
                display="menu"></p-columnFilter>
              </div>
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-disbRecordJobs let-columns="columns">
          <tr>
            <td>
              <div class="flex align-items-center">
                <button class="btn btn-warning btn-sm mr-2" pTooltip="Preview batch details" appActionTooltip
                  style="margin-right: 4%;"
                  (click)="preview(disbRecordJobs)" role="button"><i
                class="mdi mdi-eye"></i></button>

                <button class="btn btn-success btn-sm mr-2" pTooltip="Download in QuickBooks format" appActionTooltip
                  style="margin-right: 4%;"
                  (click)="download(disbRecordJobs)" role="button"><i
                class="mdi mdi-download"></i></button>
              </div>

            </td>
            @for (col of columns; track col) {
              <td>
                {{disbRecordJobs[col.field] }}
              </td>
            }
          </tr>

        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns && columns.length">
              {{gridCustomMessage?gridCustomMessage:'No records found'}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showTrDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '90%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>

    <p-table #dt [columns]="previewCols"  [(value)]="previewData" dataKey="id" [scrollable]="true" scrollDirection="both"
      scrollHeight="400px" styleClass="p-datatable-daywiseData" responsiveLayout="scroll" rows="5"
      [rowHover]="true" class="insidetable" [loading]="loading" responsiveLayout="scroll">

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="id">
            <div>
              ID
              <p-sortIcon field="id"></p-sortIcon>
              <p-columnFilter [showOperator]="false" [showAddButton]="false"  type="text" field="id"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="datePaid">
            <div>
              Date Paid
              <p-sortIcon field="datePaid"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="taskId">
            <div>
              Task ID
              <p-sortIcon field="taskId"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="taskId"
              display="menu"></p-columnFilter>
            </div>
          </th>

          <th pSortableColumn="splOrgName">
            <div>
              Organization Name
              <p-sortIcon field="splOrgName"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="splOrgName"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="splMatterName">
            <div>
              Matter Name
              <p-sortIcon field="splMatterName"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="splMatterName"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="transactionType">
            <div>
              Transaction Type
              <p-sortIcon field="transactionType"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="transactionType"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="transAccountName">
            <div>
              TRNS Account
              <p-sortIcon field="transAccountName"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="transAccountName"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="splAccountName">
            <div>
              SPL Account
              <p-sortIcon field="splAccountName"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="splAccountName"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="splReimbexp">
            <div>
              Reimb Exp
              <p-sortIcon field="splReimbexp"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="splReimbexp"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="splTaskDescription">
            <div>
              Task Description
              <p-sortIcon field="splTaskDescription"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="splTaskDescription"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="transName">
            <div>
              Payee Name
              <p-sortIcon field="transName"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="transName"
              display="menu"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="transDisbursementAmount">
            <div>
              Disbursement Amount
              <p-sortIcon field="transDisbursementAmount"></p-sortIcon>
              <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="transDisbursementAmount"
              display="menu"></p-columnFilter>
            </div>
          </th>


        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-disbRecordJobs let-columns="columns">
        <tr>
          @for (col of columns; track col) {
            <td>
              {{disbRecordJobs[col.field] }}
            </td>
          }
        </tr>

      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns && columns.length">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>